import { FeatureCollection } from 'geojson';
import ExportSectionFeaturesButton, {
  ExportSectionFeaturesButtonProps,
} from './ExportSectionFeaturesButton';

const ExportSectionJsonButton = (props: ExportSectionFeaturesButtonProps) => {
  const transformFeatures = (featureColl: FeatureCollection) =>
    JSON.stringify(featureColl);
  return (
    <ExportSectionFeaturesButton
      {...props}
      contentType="application/json"
      extension="json"
      transformFeatures={transformFeatures}
      zipTitle="GeoJSON"
    />
  );
};

export default ExportSectionJsonButton;
